let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hR6SG"), load("7lvZk"), load("kIryJ")]).then(() => parcelRequire('j2TUq'));